<template>

    <div :ref="'dropdown-holder-'+userStoryId" class="dropdown d-inline-block user-story-actions">
        <button :ref="'dropdown-'+userStoryId" type="button" v-dropdown data-bs-auto-close="outside" class="btn dropdown-toggle"><i class="fa fa-plus"></i> {{type}}</button>

        <div class="dropdown-menu" v-on:click.stop>
            <h4>Add {{type}}</h4>
            <div class="mb-3">
                <label class="control-label">Title</label>
                <input ref="title" type="text" v-model="item.title" class="form-control" @keypress.enter="save()" data-vv-name="title" data-vv-validate-on="blur" data-vv-as="title" v-validate="'required'">
                <help-block field="title"/>
            </div>


            <div class="mb-3">
                <label class="control-label">Assigned</label>
                <user-select :user="item.user" :userChanged="userSelected" :inline="true"></user-select>
            </div>

            <div class="text-end">
                <button type="button" @click="close()" class="btn btn-rounded btn-light me-1">Cancel</button>
                <button type="button" @click="save()" class="btn btn-rounded btn-primary">Save</button>
            </div>
        </div>
    </div>

</template>

<script>
    import { Dropdown } from 'bootstrap-5'

    import { notify } from 'utils'
    import Multiselect from 'vue-multiselect'
    import { filter, cloneDeep } from 'lodash'
    import Item from './../../../../models/item.js'
    import { mapState, mapActions, mapGetters } from 'vuex'
    import UserSelect from 'components/form/input/_user-select'


    export default {
        $_veeValidate: {
            validator: 'new' // give me my own validator scope.
        },
        props: ['propTask', 'userStoryId', 'type'],
        components: {
            Multiselect,
            UserSelect,
            Item
        },

        data: function () {
            return {
                item: new Item(),
            }
        },

        mounted () {
            this.$refs['dropdown-holder-'+this.userStoryId].addEventListener('shown.bs.dropdown', () => {
                this.$validator.reset()
                this.$refs.title.focus()
                this.item.user = this.authorizedSelect
                this.userSelected(this.authorizedSelect)
            })
        },

        computed: {
            ...mapState('users', ['users']),
            ...mapGetters('yodizproject/stories', {
                getStoryById: 'getById'
            }),
            ...mapGetters('yodizproject/tasks', {
                getTaskById: 'getById'
            }),
            ...mapGetters('user', ['authorizedSelect']),


        },

        methods: {
            ...mapActions('yodizproject/tasks', {
                addTaskListObject: 'addListObject'
            }),

            close () {
                Dropdown.getOrCreateInstance(this.$refs['dropdown-'+this.userStoryId]).hide()
            },
            async save() {

                if (!await this._validate()) {
                    notify.error('Form validation failed, please check your inputs and try again.')
                    return
                }

                this.addTaskListObject({payload: Object.assign(this.item, {'story_id': this.userStoryId, 'user_story_doc_id': this.$route.params.user_story_doc_id, type: this.type})}).then(() => {
                    this.$validator.reset()
                    this.item = new Item()
                    this.userSelected(this.authorizedSelect)
                });
            },
            userSelected(user) {
                this.item.owner_id = user.id
                this.item.user = user
            }
        }
    }
</script>

<style >
</style>
